import React from "react";
import { Box, Typography, Grid, TextField, Checkbox, Link, IconButton } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import EmailIcon from "@mui/icons-material/Email";
import ChatIcon from "@mui/icons-material/Chat";

export default function Footer() {
  
  return (
    <Box sx={{ backgroundColor: "rgb(18, 44, 57)", color: "white", p: 4}}>
      <Grid container spacing={4} justifyContent="space-between" style={{marginTop:'3%'}}>
        {/* Logo & DOT/MC */}
        <Grid item xs={12} sm={3}>
          <Box display="flex" alignItems="center" mb={2}>
            <img src="/logo.png" alt="Logo" style={{wodth:'170px',height:'180px'}} />
         
          </Box>
          {/* <Typography variant="body1">
            <strong>DOT:</strong> 4079367
          </Typography>
          <Typography variant="body1">
            <strong>MC:</strong> 1551598
          </Typography> */}
        </Grid>

        {/* Office Info */}
        <Grid item xs={12} sm={3}>
          <Typography variant="h6" fontWeight="bold" style={{  fontFamily: "Poppins, sans-serif",}}>Office</Typography><br/>
          <Typography variant="body2">117 S Lexington st STE Harrisonville MO</Typography>
          <Link href="mailto:infinityautoship@gmail.com" underline="hover" sx={{ display: "block", mt: 1 }}>
          infinityautoship@gmail.com
          </Link><br/>
          <Typography variant="body2">
  <Link href="tel:2078044726" color="inherit" underline="none">
    (207) 804-4726
  </Link>
</Typography>
        </Grid>

        {/* Links */}
        <Grid item xs={12} sm={2}>
          <Typography variant="h6" fontWeight="bold" style={{  fontFamily: "Poppins, sans-serif",}}>Links</Typography><br/>
          <Link href="/about-us" underline="hover" display="block" color="inherit">About Us</Link>
          <Link href="/privacy-policy" underline="hover" display="block" color="inherit">Privacy Policy</Link>
          <Link href="/" underline="hover" display="block" color="inherit">Contact us</Link>
        </Grid>

        {/* Newsletter */}
        <Grid item xs={12} sm={4}>
          <Typography variant="h6" fontWeight="bold"style={{  fontFamily: "Poppins, sans-serif",}}>Newsletter</Typography><br/>
          <Box display="flex" alignItems="center" borderBottom="1px solid white" pb={1} mt={1}>
            <EmailIcon sx={{ mr: 1 }} />
            <TextField
              variant="standard"
              placeholder="Enter Your Email Address"
              InputProps={{ disableUnderline: true, sx: { color: "white" } }}
              fullWidth
            />
            <IconButton sx={{ color: "white" }}>
              <SendIcon />
            </IconButton>
          </Box>
          <Box display="flex" alignItems="center" mt={1}>
            <Checkbox sx={{ color: "white" }} size="small" />
            <Typography variant="body2">
              I agree to the <Link href="#" underline="hover" color="inherit">Privacy Policy</Link>.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Footer Bottom */}
      <Box textAlign="center" mt={4}>
        <Typography variant="body2">Infinity Autoship © 2025. All Rights Reserved.</Typography>
      </Box>

      {/* Floating Chat Icon */}
      <IconButton
        sx={{
          position: "fixed",
          bottom: 16,
          right: 16,
          backgroundColor: "white",
          color: "#0a0c1b",
          "&:hover": { backgroundColor: "gray" }
        }}
      >
        <ChatIcon />
      </IconButton>
    </Box>
  );
}
